import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './BlockHeading.scss';

function BlockHeading({ title, withResetButton = false, onResetClick = () => {} }) {
  return (
    <div className="heading">
      {withResetButton && (
        <ButtonWithIcon
          data-e2e="preferences-reset-to-default"
          type="link"
          size="small"
          linkIconSize="s"
          sprite="Undo"
          iconRight
          onClick={onResetClick}
          className="heading-reset">
          Reset to default
        </ButtonWithIcon>
      )}
      <div className="heading-title">{title}</div>
    </div>
  );
}

BlockHeading.propTypes = {
  title: PropTypes.string,
  withResetButton: PropTypes.bool,
  onResetClick: PropTypes.func,
};

export default BlockHeading;
